import React, { useState, useEffect } from "react";
import { LightGroup } from "../../../Classes/LightGroup";
import image from "../../../../assets/img/subsolos/subsolo-01.png";
import Ligado from "../../../../assets/img/Ligado.png";
import Desligado from "../../../../assets/img/Desligado.png";
import { lightGroupsConfig } from "../../configs/SubsoloLightConfig";

const Subsolo01 = ({ luzesStatus }) => {
  const [groupRefs, setGroupRefs] = useState({});
  const [imageStates, setImageStates] = useState({});
  
  // Obtém o grupo do subsolo atual
  const grupos = lightGroupsConfig.subsolo01;
  
  // Inicializa os refs e imageStates baseados na configuração
  useEffect(() => {
    const refs = {};
    const initialStates = {};
    
    grupos.forEach(grupo => {
      refs[grupo.id] = React.createRef();
      initialStates[grupo.id] = true; // Valor inicial
    });
    
    setGroupRefs(refs);
    setImageStates(initialStates);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateLightGroup = (data) => {
    if (!data || !Array.isArray(data)) {
      console.error("Dados inválidos recebidos para updateLightGroup.");
      return;
    }

    const newStates = {};
    
    grupos.forEach(grupo => {
      // Convertemos para números, já que na configuração são strings
      const moduloIndex = parseInt(grupo.modulo) - 1; // Ajustando para índice baseado em 0
      const dadosIndex = parseInt(grupo.idx) - 1;   // Ajustando para índice baseado em 0
      
      // Verificamos se os dados existem e obtemos o status
      if (data[moduloIndex] && data[moduloIndex].dados && data[moduloIndex].dados[dadosIndex] !== undefined) {
        newStates[grupo.id] = data[moduloIndex].dados[dadosIndex] === "ON";
      } else {
        console.warn(`Dados não encontrados para o grupo ${grupo.id} (módulo ${moduloIndex}, índice ${dadosIndex})`);
        // Mantém o estado anterior em caso de dados ausentes
        newStates[grupo.id] = imageStates[grupo.id] || false;
      }
    });
    
    setImageStates(prevStates => ({
      ...prevStates,
      ...newStates
    }));
  };

  const handleToggleLightGroup = (groupId, newImageState) => {
    setImageStates((prevState) => ({
      ...prevState,
      [groupId]: newImageState,
    }));
  };

  useEffect(() => {
    updateLightGroup(luzesStatus);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [luzesStatus]);

  return (
    <div className="subSoloSelecionado">
      <img className="imagemSubsolo" src={image} alt="subsolo" />

      {grupos.map(grupo => (
        grupo.instances.map((instance, index) => (
          <LightGroup
            key={`${grupo.id}-${index}`}
            className="light_button"
            ref={index === 0 ? groupRefs[grupo.id] : undefined}
            groupId={`${grupo.id}-${index}`}
            descricao={grupo.descricao}
            imageUrl={imageStates[grupo.id] ? Ligado : Desligado}
            onCommand={{ modulo: grupo.modulo, idx: grupo.idx, status: "ON" }}
            offCommand={{ modulo: grupo.modulo, idx: grupo.idx, status: "OFF" }}
            x={instance.x}
            y={instance.y}
            width={instance.width}
            height={instance.height}
            circleNumber={instance.circleNumber}
            imageState={imageStates[grupo.id]}
            onToggleLightGroup={(id, state) => handleToggleLightGroup(grupo.id, state)}
          />
        ))
      ))}

      {grupos.map(grupo => (
        <div 
          key={`clickable-${grupo.id}`}
          id="campo-clickable-element-subsolo" 
          className="campo-clickable-element"
        >
          <div
            id="clickable-element-sub"
            className="clickable-element"
            onClick={() => {
              if (groupRefs[grupo.id] && groupRefs[grupo.id].current) {
                handleToggleLightGroup(grupo.id, !imageStates[grupo.id]);
                groupRefs[grupo.id].current.sendCommand(
                  grupo.descricao,
                  imageStates[grupo.id]
                    ? { modulo: grupo.modulo, idx: grupo.idx, status: "OFF" }
                    : { modulo: grupo.modulo, idx: grupo.idx, status: "ON" }
                );
              } else {
                console.warn(`Referência para ${grupo.id} não está disponível ainda.`);
              }
            }}
          >
            <p className={`NumberTextBar${imageStates[grupo.id] ? "Highlighted" : ""}`}>
              {grupo.instances[0].circleNumber}
            </p>
            <p className="textBar">{grupo.descricao}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Subsolo01;